import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiGateway, useEnrolmentStatusContext } from "../context";
import {
  ErrorType,
  onQuestionChallengeAxiosErrorInterpreter,
} from "@screens/FeaAuth/hooks/onQuestionChallengeError";

export type CreateClaveUnicaURL = {
  url?: string | null;
  alreadyValid?: boolean;
  message?: string | null;
};

type MutationProps = {
  requestId?: string;
};

type Props = {
  onError: (error: Error) => void;
};

export const useGetClaveUnicaUrl = ({ onError }: Props) => {
  // Show loading spinner depending on the state of the esign flow
  // but adding a delay to consider the redirection to the 'clave unica' login
  const [isGettingClaveUnicaUrl, setIsGettingClaveUnicaUrl] = useState(false);
  const { getEnrolmentStatus } = useEnrolmentStatusContext();
  return {
    getClaveUnicaUrlMutation: useMutation({
      mutationFn: (variables: MutationProps) =>
        apiGateway<CreateClaveUnicaURL, ErrorType>(
          {
            method: "post",
            url: "/enrolment/clave-unica",
            data: {
              requestId: variables?.requestId ?? null,
            },
          },
          onQuestionChallengeAxiosErrorInterpreter,
        ),
      onMutate: () => {
        setIsGettingClaveUnicaUrl(true);
      },
      onSuccess: async (data) => {
        if (data.alreadyValid) {
          await getEnrolmentStatus();
          return;
        }
        if (data.url) {
          window.location.href = data.url;
          return;
        }
        console.error(
          "Clave unica url response without url nor alreadyValid: ",
          data,
        );
        await getEnrolmentStatus();
      },
      onError,
      onSettled: () => {
        const timeoutId = setTimeout(() => {
          setIsGettingClaveUnicaUrl(false);
        }, 5000);
        return () => clearTimeout(timeoutId);
      },
    }),
    isGettingClaveUnicaUrl,
  };
};
